<template>
  <div>
    <transition name="message-app-editor-overlay" @after-enter="handleAfterEnterOverlay" @after-leave="handleAfterLeaveOverlay">
      <div class="pa-message-app-editor-overlay" v-if="isOpenOverlay"></div>
    </transition>

    <transition name="message-app-editor-overlay-content" @after-leave="handleAfterLeaveContent">
      <div class="pa-message-app-editor-overlay-content" v-if="isOpenContent">
        <template v-if="isLoading">
          <PuffLoadingImage class="waiting-loader" stroke="#d1d1d1" />
        </template>
        <template v-else>
          <div
           class="cancel-button"
           :class="additionalButonClass"
           @click.prevent="handleClickCancelButton"
          >{{cancelButtonText}}</div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import PuffLoadingImage from '@/components/Pages/Office/ContentLoadingSheild/Images/puff.svg?inlineN'

export default {
  props : {
    isOpen  : {
      default : false
    },

    isLoading : {
      default: false
    },

    cancelButtonText  : {
      default : '閉じる'
    }
  },

  components : {
    PuffLoadingImage
  },

  data(){
    return {
      isRunning     : false,

      isOpenOverlay : false,
      isOpenContent : false,

      additionalButonClass : {
        'cancel-button-running' : false,
      }
    };
  },

  watch : {
    isOpen : {
      handler(value){
        if(value === true){
          this.isOpenOverlay = true;
        }else{
          this.isOpenContent = false;
        }
      },
      immediate:true
    },

    isRunning : {
      handler(value){
        if(value === true){
          this.additionalButonClass['cancel-button-running'] = true;
        }else{
          this.additionalButonClass['cancel-button-running'] = false;
        }
      },
      immediate: true
    }
  },

  methods : {
    handleAfterEnterOverlay(){
      this.isOpenContent = true;
    },

    handleAfterLeaveOverlay(){
      this.isRunning = false;

      this.$emit('onClose');
    },

    handleAfterLeaveContent(){
      this.isOpenOverlay = false;
    },

    handleClickCancelButton(){
      if(this.isRunning) return;

      this.isRunning = true;
      
      this.$emit('onClickClose');
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.message-app-editor-overlay, .message-app-editor-overlay-content{
  &-enter-active{
    opacity: 1;
    transition: opacity 200ms ease-in;
  }

  &-leave-active{
    transition: opacity 200ms ease-in;
  }

  &-enter, &-leave-to{
    opacity: 0;
  }
}

.pa-message-app-editor{
  &-overlay{
    width:100%;
    height:100%;
    position:absolute;
    top:0;
    left:0;
    background:rgba(#4D0B25, .7);
    z-index: 1000;
  }

  &-overlay-content{
    width:100%;
    height:100%;
    position: absolute;
    top:0;
    left:0;
    background-color: inherit;
    z-index: 1001;
    display: flex;
    justify-content: center;
    align-items: center;

    .cancel-button{
      margin-top:-.5rem;
      letter-spacing: 1px;
      color:#d1d1d1;
      border-bottom:1.5px solid #d1d1d1;
      padding-bottom:3px;
      line-height: 1;
      user-select: none;

      &-running{
        text-shadow: 1px 1px 30px #d1d1d1;
        opacity:.6;
        transition: opacity 500ms, text-shadow 50ms;
      }
    }
  }
}
</style>